<template>
  <div>
    <!-- :before-close="handleClose" -->
    <el-drawer
      :title="title"
      :visible.sync="drawer"
      size="90%"
      :wrapperClosable="false"
    >
      <div class="form-center" v-loading="loading">
        <el-form :model="form" ref="form" label-width="130px" :rules="rules">
          <!-- <el-form-item label="头像" prop="HeadImg" class="Describe">
            <el-upload
              class="avatar-uploader"
              :action="$rootUrl + `/Base_Manage/Upload/UploadFileByForm`"
              :headers="{
                Authorization: token,
              }"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <el-image
                v-if="form.HeadImg"
                fit="contain"
                class="HeadImg"
                :src="form.HeadImg"
              ></el-image>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item> -->
          <el-row>
            <el-col :span="6">
              <el-form-item label="资产编号" prop="AssetCode">
                <el-input
                  v-model="form.AssetCode"
                  placeholder="请输入资产编号"
                  :disabled="disabled || title == '编辑资产信息'"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="资产名称" prop="AssetName">
                <el-input
                  v-model="form.AssetName"
                  placeholder="请输入资产名称"
                  :disabled="disabled || title == '编辑资产信息'"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="资产类型" prop="AssetTypeId">
                <SelectData
                  v-model="form.AssetTypeId"
                  :disabled="disabled"
                  placeholder="请选择资产类型"
                  url="/AM/AM_AssetType/GetDataList"
                  :option="{
                    label: 'AssetType',
                    Id: 'Id',
                  }"
                ></SelectData>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="资产分类" prop="AssetCategoryId">
                <SelectData
                  v-model="form.AssetCategoryId"
                  :disabled="disabled"
                  placeholder="请选择资产分类"
                  url="/AM/AM_AssetCategory/GetDataList"
                  :option="{
                    label: 'AssetCategory',
                    Id: 'Id',
                  }"
                ></SelectData>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="资产规格型号" prop="AssetSpec">
                <el-input
                  v-model="form.AssetSpec"
                  :disabled="disabled"
                  placeholder="请输入资产规格型号"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="资产位置" prop="AssetPosition">
                <el-input
                  v-model="form.AssetPosition"
                  :disabled="disabled"
                  placeholder="请输入资产位置"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="折旧方法" prop="Depreciations">
                <SelectData
                  v-model="form.Depreciations"
                  :disabled="disabled"
                  url="/Base/Base_EnumItem/GetListByCode"
                  :data="{
                    id: 'Depreciations',
                  }"
                  :option="{
                    label: 'Name',
                    Id: 'Code',
                  }"
                ></SelectData>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="折旧年限(年)" prop="DepreciationYear">
                <el-input
                  type="number"
                  :disabled="disabled"
                  v-model="form.DepreciationYear"
                  placeholder="请输入折旧年限"
                  @input="calculateDepreciationDate"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="税率" prop="TaxRate">
                <el-select
                  v-model="form.TaxRate"
                  :disabled="disabled"
                  placeholder="请选择"
                  style="width: 100%"
                  clearable
                  filterable
                  @change="calculateTaxAndNatAmount"
                >
                  <el-option
                    v-for="item in TaxRateList"
                    :key="item.Value"
                    :label="item.Name"
                    :value="item.Value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="是否抵扣" prop="IsDeduction">
                <el-radio-group
                  v-model="form.IsDeduction"
                  @change="calculateEvaluationValue"
                  :disabled="disabled"
                >
                  <el-radio :label="false">否</el-radio>
                  <el-radio :label="true">是</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="数量" prop="Qty">
                <el-input
                  v-model="form.Qty"
                  disabled
                  placeholder="请输入数量"
                  type="number"
                  @input="NumChange"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="含税单价" prop="Price">
                <el-input
                  v-model="form.Price"
                  :disabled="disabled"
                  placeholder="请输入单价"
                  type="number"
                  @input="PriceChange"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="含税金额" prop="Amount">
                <el-input
                  v-model="form.Amount"
                  disabled
                  placeholder="金额"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="税额" prop="TaxAmount">
                <el-input
                  v-model="form.TaxAmount"
                  disabled
                  placeholder="税额"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="不含税金额" prop="NatAmount">
                <el-input
                  v-model="form.NatAmount"
                  disabled
                  placeholder="不含税金额"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="原值" prop="OriginalValue">
                <el-input
                  v-model="form.OriginalValue"
                  disabled
                  placeholder="原值"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="变动值" prop="ChangeAmount">
                <el-input
                  v-model="form.ChangeAmount"
                  disabled
                  placeholder="变动值"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="评估后值" prop="EvaluationValue">
                <el-input
                  v-model="form.EvaluationValue"
                  disabled
                  placeholder="评估后值"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="残值率(%)" prop="ResidualValueRate">
                <el-input
                  type="number"
                  :disabled="disabled"
                  v-model="form.ResidualValueRate"
                  placeholder="请输入残值率"
                  @input="calculateEvaluationValue"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="净值" prop="NetValue">
                <el-input
                  v-model="form.NetValue"
                  disabled
                  placeholder="净值"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="残值" prop="NetSalvage">
                <el-input
                  v-model="form.NetSalvage"
                  disabled
                  placeholder="残值"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="使用状态" prop="Status">
                <SelectData
                  v-model="form.Status"
                  :disabled="disabled"
                  url="/Base/Base_EnumItem/GetListByCode"
                  :data="{
                    id: 'AssetStatus',
                  }"
                  :option="{
                    label: 'Name',
                    Id: 'Code',
                  }"
                ></SelectData>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="是否折旧" prop="DepreciationStatus">
                <el-radio-group
                  v-model="form.DepreciationStatus"
                  :disabled="disabled"
                >
                  <el-radio :label="0">否</el-radio>
                  <el-radio :label="1">是</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="管理部门" prop="ResponsibleDept">
                <SelectData
                  v-model="form.ResponsibleDept"
                  :disabled="disabled"
                  url="/AM/AM_Department/GetDataList"
                  :option="{
                    label: 'DepartmentName',
                    Id: 'Id',
                  }"
                ></SelectData>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="管理部门负责人" prop="Custodian">
                <el-input
                  v-model="form.Custodian"
                  placeholder="部门负责人"
                  :disabled="disabled"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="管理部门联系方式" prop="PhoneNumber">
                <el-input
                  v-model="form.PhoneNumber"
                  :disabled="disabled"
                  placeholder="请输入部门联系方式"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="使用部门" prop="UserDepartment">
                <SelectData
                  v-model="form.UserDepartment"
                  :disabled="disabled"
                  url="/AM/AM_Department/GetDataList"
                  :option="{
                    label: 'DepartmentName',
                    Id: 'Id',
                  }"
                ></SelectData>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="使用日期" prop="PurchaseDate">
                <el-date-picker
                  v-model="form.PurchaseDate"
                  :disabled="disabled"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  style="width: 100%"
                  @input="calculateDepreciationDate"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="计提选项" prop="Flag">
                <el-radio-group
                  v-model="form.Flag"
                  @change="calculateDepreciationDate"
                  :disabled="disabled"
                >
                  <el-radio :label="0">当月</el-radio>
                  <el-radio :label="1">次月</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="折旧开始年月" prop="DStartYearMonth">
                <el-input
                  v-model="form.DStartYearMonth"
                  disabled
                  placeholder="折旧开始年月"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="折旧结束年月" prop="DEndYearMonth">
                <el-input
                  v-model="form.DEndYearMonth"
                  disabled
                  placeholder="折旧结束年月"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="备注" prop="Remark">
                <el-input
                  v-model="form.Remark"
                  :disabled="disabled"
                  placeholder=""
                  type="textarea"
                  rows="3"
                  resize="none"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-row v-if="title !== '新建资产信息'">
          <el-button type="primary" @click="openAddDev">添加设备</el-button>
        </el-row>
        <el-table
          v-if="title !== '新建资产信息'"
          :data="form.device_Fixeds"
          ref="table"
          style="width: 100%"
        >
          <el-table-column label="序号" width="50" type="index">
          </el-table-column>

          <el-table-column label="设备编号" align="center" prop="device_no">
          </el-table-column>
          <el-table-column label="设备名称" align="center" prop="device_name">
          </el-table-column>
          <el-table-column label="设备型号" align="center" prop="model_number">
          </el-table-column>
          <el-table-column label="设备规格" align="center" prop="specification">
          </el-table-column>
          <el-table-column
            label="安装位置"
            align="center"
            prop="InstallationAreaName"
          >
          </el-table-column>
          <el-table-column
            label="生产厂家名称"
            align="center"
            prop="manufacturer"
          >
          </el-table-column>
          <el-table-column label="购置价格" align="right" prop="purchase_price">
            <template slot-scope="scope">
              {{ $tools.momenyFormat(scope.row.purchase_price, 2) }}
            </template>
          </el-table-column>
          <el-table-column label="设备数量" align="center" prop="Num">
          </el-table-column>
          <el-table-column label="金额" align="right" prop="Amount">
            <template slot-scope="scope">
              {{ $tools.momenyFormat(scope.row.Amount, 2) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" prop="op" width="60px">
            <template slot-scope="scope">
              <el-button
                type="text"
                style="color: #f56c6c"
                @click="tableDeteled(scope)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer" v-loading="loading">
        <el-button @click="close">取消</el-button>
        <el-button v-if="!disabled" type="primary" @click="handleSubmit(0)"
          >保存</el-button
        >
        <el-button v-if="!disabled" type="primary" @click="handleSubmit(1)"
          >提交</el-button
        >
      </div>
    </el-drawer>
    <AddDevDialog ref="AddDevDialog" @select="subDev"></AddDevDialog>
  </div>
</template>
<script>
import Token from '@/utils/cache/TokenCache.js'
import SelectData from '@/components/SelectData/SelectData.vue'
import AddDevDialog from './AddDevDialog.vue'

export default {
  data() {
    return {
      title: '',
      loading: false,
      disabled: false,
      token: 'Bearer ' + Token.getToken(),
      RoleList: [],
      TaxRateList: [],
      row: {},
      form: {
        AssetCode: '',
        AssetName: '',
        AssetTypeId: '',
        AssetCategoryId: '',
        AssetSpec: '',
        AssetPosition: '',
        Depreciations: '',
        DepreciationPeriod: 0,
        DepreciationYear: '',
        ResidualValueRate: '',
        Qty: 1,
        Price: '',
        Amount: '',
        Status: '',
        ResponsibleDept: '',
        UserDepartment: '',
        Custodian: '',
        PhoneNumber: '',
        PurchaseDate: '',
        Remark: '',
        device_Fixeds: [],
        Flag: 0,
        TaxRate: 0,
        IsDeduction: false,
        OriginalValue: 0,
        DepreciationStatus: 1,
        ChangeAmount: 0,
        DStartYearMonth: null,
        DEndYearMonth: null,
        ScrapType: '正常',
      },
      rules: {
        AssetCode: [
          { required: true, message: '请输入资产编码', trigger: 'blur' },
        ],
        AssetName: [
          { required: true, message: '请输入资产名称', trigger: 'blur' },
        ],
        AssetTypeId: [
          { required: true, message: '请选择资产类型ID', trigger: 'change' },
        ],
        AssetCategoryId: [
          { required: true, message: '请选择资产分类', trigger: 'change' },
        ],
        Status: [{ required: true, message: '请选择状态', trigger: 'change' }],
        Price: [{ required: true, message: '请输入单价', trigger: 'blur' }],
        TaxRate: [{ required: true, message: '请选择税率', trigger: 'change' }],
        Depreciations: [
          { required: true, message: '请选择折旧方法', trigger: 'change' },
        ],
        DepreciationYear: [
          { required: true, message: '请输入折旧年限', trigger: 'blur' },
        ],
        ResidualValueRate: [
          { required: true, message: '请输入残值率', trigger: 'blur' },
        ],
        ResponsibleDept: [
          { required: true, message: '请选择管理部门', trigger: 'change' },
        ],
        UserDepartment: [
          { required: true, message: '请选择使用部门', trigger: 'change' },
        ],
        PurchaseDate: [
          { required: true, message: '请选择使用日期', trigger: 'blur' },
        ],
        Flag: [
          { required: true, message: '请选择计提选项', trigger: 'change' },
        ],
        IsDeduction: [
          { required: true, message: '请选择是否抵扣', trigger: 'change' },
        ],
      },
      drawer: false,
    }
  },
  props: {},
  components: { SelectData, AddDevDialog },
  methods: {
    subDev(rows) {
      rows.forEach((item) => {
        this.$set(item, 'FixedAssetsCode', this.form.AssetCode)
        this.$set(item, 'FixedAssetsName', this.form.AssetName)
        this.$set(item, 'DeviceId', item.Id)
        this.$set(item, 'Id', '')
        this.$set(item, 'Status', 1)
      })
      console.log(rows)
      this.loading = true
      this.$http
        .post('/Base_DeviceTreeManage/Device_FixedAssets/SaveDataList', [
          ...rows,
        ])
        .then((res) => {
          this.loading = false
          if (res.Success) {
            this.loading = true
            this.$http
              .post('/AM/am_asset/GetTheData', { id: this.row.Id })
              .then((resJson) => {
                this.loading = false
                if (resJson.Success) {
                  this.$notify.success('添加设备成功')
                  this.form.device_Fixeds = [...resJson.Data.device_Fixeds]
                } else {
                  this.$notify.error(resJson.Msg)
                }
              })
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },
    openAddDev() {
      this.$refs.AddDevDialog.openDialog()
    },
    tableDeteled(scope) {
      console.log(scope.$index)
      let row = scope.row
      this.$confirm(`此操作将永久删除该设备, 是否继续?`, {
        type: 'warning',
      }).then(() => {
        this.loading = true
        this.$http
          .post('/Base_DeviceTreeManage/Device_FixedAssets/DeleteData', [
            row.Id,
          ])
          .then((resJson) => {
            this.loading = false
            if (resJson.Success) {
              this.$notify.success('删除成功')
              this.form.device_Fixeds.splice(scope.$index, 1)
            } else {
              this.$notify.error(resJson.Msg)
            }
          })
      })
    },
    PriceChange(price) {
      if (Number(price) < 0) {
        this.$notify.error('价格不能为负数')
        this.$set(this.form, 'Price', 0)
      } else if (!/^\d+(\.\d{1,4})?$/.test(price)) {
        this.$notify.error('价格最多只能保留四位小数')
        const validPrice = parseFloat(price).toFixed(4)
        this.$set(this.form, 'Price', validPrice)
      }
      const formattedTotalAmt = (
        (this.form.Qty || 0) * (this.form.Price || 0)
      ).toFixed(2)
      const formattedTotalAmtWithCommas = Number(formattedTotalAmt)
      this.$set(this.form, 'Amount', formattedTotalAmtWithCommas)
      this.calculateTaxAndNatAmount() // 新增：计算税额和不含税金额
    },
    NumChange(num) {
      console.log(num)
      if (!Number.isInteger(Number(num))) {
        this.$notify.error('数量不能为小数或负数')
        this.$set(this.form, 'Num', Math.floor(Number(num)))
      } else if (Number(num) < 0) {
        this.$notify.error('数量不能为小数或负数')
        this.$set(this.form, 'Num', 0)
      } else if (Number(num) > 999999) {
        this.$notify.error('数量不能超过999999')
        this.$set(this.form, 'Num', 999999)
      }

      const formattedTotalAmt = (
        (this.form.Qty || 0) * (this.form.Price || 0)
      ).toFixed(2)
      const formattedTotalAmtWithCommas = Number(formattedTotalAmt)
      this.$set(this.form, 'Amount', formattedTotalAmtWithCommas)
      this.calculateTaxAndNatAmount() // 新增：计算税额和不含税金额
    },
    // 计算评估后值、残值、净值
    calculateEvaluationValue() {
      console.log(this.form.IsDeduction)
      // 处理带千分位的含税金额（如"1,234.5678" → 1234.5678）
      const amount = Number(this.form.Amount || '') || 0
      console.log('含税金额', amount)
      // 不含税金额（已格式化）
      const natAmount = Number(this.form.NatAmount) || 0
      console.log('不含税金额', natAmount)
      // 残值率（假设输入的是百分比数值，如5代表5%）
      const residualRate = (Number(this.form.ResidualValueRate) || 0) / 100

      // 计算评估后值
      const evaluationValue =
        this.form.IsDeduction === true ? natAmount : amount
      // 计算残值和净值
      const netSalvage = evaluationValue * residualRate
      const netValue = evaluationValue - netSalvage

      console.log(evaluationValue)
      this.form.OriginalValue = evaluationValue.toFixed(2)
      this.$set(this.form, 'EvaluationValue', evaluationValue.toFixed(2))
      this.$set(this.form, 'NetSalvage', netSalvage.toFixed(2))
      this.$set(this.form, 'NetValue', netValue.toFixed(2))
    },
    // 新增计算方法
    calculateTaxAndNatAmount() {
      console.log(this.form.Amount)
      // 处理带千分位的金额字符串转换（如"1,234.5678"转为1234.5678）
      const amount = Number(this.form.Amount || '') || 0
      const taxRate = Number(this.form.TaxRate) || 0 // 假设税率值为小数形式（如0.13）
      console.log(amount)
      // 计算核心逻辑
      const natAmount = amount / (1 + taxRate) // 不含税金额=含税金额/(1+税率)
      const taxAmount = (amount * taxRate) / (1 + taxRate) // 税额=含税金额*税率/(1+税率)
      console.log(amount, natAmount, taxAmount)
      // 更新表单值（保留4位小数）
      this.$set(this.form, 'NatAmount', natAmount.toFixed(2))
      this.$set(this.form, 'TaxAmount', taxAmount.toFixed(2))
      this.calculateEvaluationValue()
    },
    // 支持当月/次月两种计提选项
    calculateDepreciationDate() {
      if (!this.form.PurchaseDate || !this.form.DepreciationYear) return

      // 提取使用日期的年月（格式2025-05-10 → 年:2025, 月:05）
      const [year, month] = this.form.PurchaseDate.split('-').slice(0, 2)
      let startYear = parseInt(year, 10)
      let startMonth = parseInt(month, 10)

      // 根据计提选项调整开始年月
      if (this.form.Flag === 1) {
        // 次月计提
        startMonth += 1
        if (startMonth > 12) {
          startMonth = 1
          startYear += 1
        }
      } // 当月计提（Flag=0）直接使用原始年月

      // 格式化开始年月（如2025年5月 → 202505）
      const startYearMonth = `${startYear}${String(startMonth).padStart(
        2,
        '0'
      )}`
      console.log(this.form.DepreciationYear)
      console.log(startMonth)
      console.log(startYear)
      // 计算结束年月（开始年月 + 折旧年限）
      const totalMonths =
        parseInt(startMonth, 10) + parseInt(this.form.DepreciationYear, 10) * 12
      console.log(totalMonths)
      const endYear = startYear + Math.floor((totalMonths - 1) / 12)
      console.log(endYear)
      const endMonth = ((totalMonths - 1) % 12) + 1 // 处理12月进位

      // 格式化结束年月
      const endYearMonth = `${endYear}${String(endMonth).padStart(2, '0')}`

      console.log(startYearMonth)
      console.log(endYearMonth)
      // 更新表单值
      this.$set(this.form, 'DStartYearMonth', startYearMonth)
      this.$set(this.form, 'DEndYearMonth', endYearMonth)
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 20

      if (!isJPG) {
        this.$notify.error('上传图片只能是 JPG 或 PNG 格式!')
      }
      if (!isLt2M) {
        this.$notify.error('上传头像图片大小不能超过 20MB!')
      }
      return isJPG && isLt2M
    },
    handleAvatarSuccess(res) {
      console.log(res, 'res')
      if (res.status == 'done') {
        this.form.HeadImg = res.url

        console.log(this.form.HeadImg)
      } else {
        this.$notify.error(res.Msg)
      }
    },
    getRoleList() {
      this.$http
        .post('/Base_Manage/Base_Role/GetDataList', {
          SortField: 'CreateTime',
          SortType: 'Desc',
        })
        .then((resJson) => {
          if (resJson.Success) {
            this.RoleList = resJson.Data
          }
        })
    },
    handleSubmit(Status) {
      this.$set(this.form, 'OperationStatus', Status)
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return this.$notify.error('请检查输入项')
        }
        this.loading = true
        this.$http.post('/AM/am_asset/SaveData', this.form).then((resJson) => {
          this.loading = false

          if (resJson.Success) {
            this.$notify.success('操作成功!')
            this.$emit('success')
            this.close()
          } else {
            this.$notify.error(resJson.Msg)
          }
        })
      })
    },
    getTaxRate() {
      this.$http
        .post('/Base/Base_EnumItem/GetListByCode', {
          id: 'TaxRate',
        })
        .then((res) => {
          if (res.Success) {
            this.TaxRateList = res.Data
          } else {
            this.TaxRateList = []
          }
        })
    },
    openForm(title, row = {}, flag) {
      this.drawer = true
      this.disabled = flag
      this.getTaxRate()
      this.row = row
      this.form = {
        AssetCode: '',
        AssetName: '',
        AssetTypeId: '',
        AssetCategoryId: '',
        AssetSpec: '',
        AssetPosition: '',
        Depreciations: '',
        DepreciationPeriod: 0,
        DepreciationYear: '',
        ResidualValueRate: '',
        Qty: 1,
        Price: '',
        Amount: '',
        Status: '',
        ResponsibleDept: '',
        UserDepartment: '',
        Custodian: '',
        PhoneNumber: '',
        PurchaseDate: '',
        Remark: '',
        device_Fixeds: [],
        Flag: 0,
        TaxRate: 0,
        IsDeduction: false,
        OriginalValue: 0,
        DepreciationStatus: 1,
        ChangeAmount: 0,
        DStartYearMonth: null,
        DEndYearMonth: null,
        ScrapType: '正常',
      }
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
      this.title = title
      if (row.Id) {
        this.getInfo(row.Id)
      }
    },
    getInfo(id) {
      this.loading = true
      this.$http.post('/AM/am_asset/GetTheData', { id: id }).then((resJson) => {
        this.loading = false
        if (resJson.Success) {
          this.form = resJson.Data
        } else {
          this.$notify.error(resJson.Msg)
        }
      })
    },
    close() {
      this.drawer = false
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(() => {
          done()
        })
        .catch(() => {})
    },
  },
  mounted() {},
  created() {},
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__header {
  margin: 0;
  padding: 20px;
}
.form-center {
  height: calc(100vh - 120px);
  overflow-y: auto;
  padding: 20px;
}
.footer {
  height: 40px;
  line-height: 40px;
  text-align: right;
  padding: 0 20px;
}
::v-deep .avatar-uploader .el-upload {
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 65px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
</style>
